import { Component } from '@angular/core';
import { AuthenticationService } from '../../views/authentication/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent {
  constructor(public service: AuthenticationService) {

  }
}



// WEBPACK FOOTER //
// ./src/app/containers/full-layout/full-layout.component.ts